import BasicFilterMultiSelect from "../../../common/BasicFilterMultiSelect";

export default function ChannelsFilterMultiSelect({ options, input, name, label, placeholder}) {

    return(
        <BasicFilterMultiSelect
            name={name}
            label={label}
            placeholder={placeholder}
            options={options}
            onChange={input.onChange}
            listBoxHeight={300}
            textFieldStyle={styles.textFieldStyle}
        />
    )
}

const styles = {
    textFieldStyle: {
        [`& fieldset`]: {
            minHeight: '50px',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderWidth: '1.5px',
                borderColor: '#9EA9A9',
                borderRadius: '8px',
            },
            '&:hover fieldset': {
                borderColor: '#0C2728',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#003300',
            },
        },
    }
}